const ALIGNER_SET_UPDATE_MODAL_TYPES = {
  SET_AND_DAY_UPDATE: 'SET_AND_DAY_UPDATE',
  CONFIRMATION_FOR_FOUR_MORE_SETS: 'CONFIRMATION_FOR_FOUR_MORE_SETS',
  CONFIRMATION_FOR_UPDATE_CHANGE: 'CONFIRMATION_FOR_UPDATE_CHANGE',
  SUCCESS: 'SUCCESS'
};

export default ALIGNER_SET_UPDATE_MODAL_TYPES;

export const Hr22InSec = 79200; // 22 hr in sec
export const Hr24InSec = 86400; // 24 hr in sec
export const HrInSec = 3600; // 24 hr in sec

export const DaysInWeek = [
  'M', 'T', 'W', 'T', 'F', 'S', 'S'
];

export const MEDIAS = {
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO'
};

export const MESSENGERS = {
  whatsapp: 'whatsapp',
  intercom: 'intercom'
};

export const LOGIN_OPTIONS = {
  EMAIL: 'EMAIL',
  MOBILE: 'MOBILE',
  LINE: 'LINE'
};

export const handleLineLogin = () => {
  const clientId = process.env.NEXT_PUBLIC_LINE_CLIENT_ID;
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const localeMatch = currentUrl.match(/\/([a-z]{2}-[a-z]{2})\//);
  const locale = localeMatch ? localeMatch[1] : 'sg-en';
  const baseRedirectUri = process.env.NEXT_PUBLIC_LINE_REDIRECT_URI || '';
  const updatedRedirectUri = baseRedirectUri.replace(/\/[a-z]{2}-[a-z]{2}\//, `/${locale}/`);
  const redirectUri = encodeURIComponent(updatedRedirectUri);
  const loginChannelId = process.env.NEXT_PUBLIC_LINE_LOGIN_CHANNEL_ID;
  const loginState = process.env.NEXT_PUBLIC_LINE_LOGIN_STATE;
  const baseUrl = process.env.NEXT_PUBLIC_LINE_AUTH_BASE_URL;

  const url = `${baseUrl}?response_type=code&client_id=${clientId}&prompt=consent`
    + `&redirect_uri=${redirectUri}&scope=profile&state=profile`
    + `&loginChannelId=${loginChannelId}&loginState=${loginState}#/qr`;

  window.location.href = url;
};

export const LINE_LOGIN_LOCALE = [
  'tw-zh', 'tw-en'
];

export const TREATMENT_TERMINAL_STATUSES = [
  'TERMINATED', 'REFUNDED', 'MIA_WITHOUT_FITTING'];

export const PRODUCT_TYPES = {
  ZENCLEAR: 'ZenyumClear™',
  ZENCLEAR_PLUS: 'ZenyumClear™ Plus',
  ZENCLEAR_EXTRA: 'ZenyumClear™ Extra'
};

export const USER_GUIDE_LINK = {
  'tw-zh': 'https://zenyum.tw/pages/correction-playbook-pdf',
  'tw-en': 'https://zenyum.tw/pages/correction-playbook-pdf',
  'hk-zh': 'https://cdn.shopify.com/s/files/1/0624/8185/8719/files/HK_play_book.pdf?v=1759998007',
  'hk-en': 'https://cdn.shopify.com/s/files/1/0624/8185/8719/files/playbook_engver.pdf?v=1765533985'
};
